<template>
    <div v-if="show">
        <!-- PC-->
        <full v-if="!mobile" :data="data"/>

        <!-- Mobile -->
        <testPageFullMobile v-if="mobile" :data="data"/>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import testPageFullMobile from "@/components/testPage/mobile/testPage_full";
    import full from "@/components/testPage/pc/full";

    export default {
        data() {
            return {
                type: null,
                result: null,
                show: false
            };
        },
        created () {
            this.type = this.data.type;
            this.result = this.data;

            // Check storage
            let prevExam = localStorage.getItem(`exam_${this.checkExam(this.data.examId, this.data.courseId)}`);

            if (prevExam == null && this.data.isDoing == 1) {
                let message = [];
                let h = this.$createElement;
                message.push(h("p", null, this.$t("new.title187")));
                // message.push(h("p", null, this.$t("new.title188")));
                this.$confirm(h("p", null, message), window.vm.$i18n.t("js.hint"), {
                    confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    cancelButtonText: window.vm.$i18n.t("js.cancel"),
                    cancelButtonClass: "btn-custom-cancel",
                    type: "",
                }).then(() => {

                    // Mở bài thi
                    this.show = false;
                    this.$nextTick(() => {
                        this.show = true;
                    });
                }).catch(() => {});
            } else {
                // Mở bài thi
                this.show = false;
                this.$nextTick(() => {
                    this.show = true;
                });
            }

        },
        components: {
            testPageFullMobile,
            full
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
            }),
        },
        methods: {
            // Thay đổi kiểu hiển thị
            toogleType: function (type) {
                this.type = type;
                this.result.type = type;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/testPage/testPage.vue